/* eslint-disable react-hooks/exhaustive-deps */
// Page Semua Loker
// --------------------------------------------------------

import React, { useEffect, useState } from "react";
import Title from "../../../components/Title";
import { styled } from "@mui/material/styles";
import Table from "../../../components/Table";
import PageNextPrev from "../../../components/PageNextPrev";
import Button from "../../../components/Button";
import InputAdornment from "@mui/material/InputAdornment";
import InputText from "../../../components/InputText";
import Colors from "../../../utils/helpers/colors";
import Menu from "@mui/material/Menu";
import DropDown from "../../../components/DropDown";
import moment from "moment";

// Redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getJobType,
  setPagination,
  setValueJobType,
  setValueSector,
  setValueStatus,
  getLokerFilter,
  setSearch,
  setActiveStep,
  getAllCity,
  setValueCity,
  setActivePage,
  getLokerExport,
  setSelectedData,
  getDetailLoker,
  executeLoker,
} from "../../../store/actions/dataLoker";

// Asset
import iconSlider from "../../../assets/icon/icon-slider.png";
import iconSearch from "../../../assets/icon/icon-search.png";
import iconXls from "../../../assets/icon/icon-xls-white.png";
import iconPlus from "../../../assets/icon/icon-plus-white.svg";
import PopUp from "../../../components/PopUp";
import iconDelete from "../../../assets/icon/business-icon-decline.png";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { setTableRows } from "../../../store/actions/setting";

const SemuaLoker = ({ setHistory }) => {
  // Get data redux
  const {
    allLoker,
    pagination,
    dropDownSector,
    valueSector,
    dropDownJobType,
    valueJobType,
    valueStatus,
    search,
    allCity,
    valueCity,
    activePage,
    totalPage,
    totalData,
  } = useSelector((state) => state.dataLoker, shallowEqual);

  const { tableRows } = useSelector((state) => state.setting);

  const dispatch = useDispatch();

  const [menuFilter, setMenuFilter] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const headerTable = [
    {
      title: "No",
      key: "loker_id",
      width: 30,
      render: (_, index) => <p>{(activePage - 1) * tableRows + (index + 1)}</p>,
    },
    {
      title: "Posisi",
      key: "job_position",
    },
    {
      title: "Perusahaan",
      key: "name",
    },
    {
      title: "Lokasi",
      key: "city",
    },
    {
      title: "Tanggal Buka",
      key: "start_open",
      render: (rowData) => (
        <p>{moment(rowData.start_open).format("DD MMMM YYYY")}</p>
      ),
    },
    {
      title: "Sektor",
      key: "sector",
    },
    {
      title: "Status",
      key: "status",
      width: 120,
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {rowData.status === "1" ? (
            <div
              style={{
                border: "1px solid #039C40",
                backgroundColor: "#96f5bf",
                borderRadius: "30px",
                padding: "4px 20px",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "16px",
                color: "#039C40",
                whiteSpace: "nowrap",
              }}
            >
              Disetujui
            </div>
          ) : rowData.status === "2" ? (
            <div
              style={{
                border: "1px solid #C80707",
                backgroundColor: "#F5969633",
                borderRadius: "30px",
                padding: "4px 20px",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "16px",
                color: "#C80707",
                whiteSpace: "nowrap",
              }}
            >
              Ditolak
            </div>
          ) : (
            <div
              style={{
                border: "1px solid #115abe",
                backgroundColor: "#bde2fc",
                borderRadius: "30px",
                padding: "4px 20px",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "16px",
                color: "#115abe",
                whiteSpace: "nowrap",
              }}
            >
              Menunggu
            </div>
          )}
        </div>
      ),
      center: true,
    },
    {
      title: "Aksi",
      key: "action",
      render: (rowData) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <Button
            variant="contained"
            borderRadius="5px"
            padding="0px 7px 0px 9px"
            onClick={() => {
              dispatch(setSelectedData(rowData));
              dispatch(getDetailLoker());
              setHistory("all");
            }}
            style={{ whiteSpace: "nowrap", width: "100%" }}
          >
            Detail
          </Button>
          <Button
            variant="contained"
            borderRadius="5px"
            padding="0 9px"
            style={{
              backgroundColor: "#FB7171",
              width: "100%",
            }}
            onClick={() => {
              dispatch(setSelectedData(rowData));
              setConfirmDelete(true);
            }}
          >
            Hapus
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  // Render pertama untuk get data
  useEffect(() => {
    dispatch(getJobType());
    dispatch(getAllCity());
    dispatch(getLokerFilter());
  }, []);

  // Jika page yang aktif sama dengan total page, maka simpan maksimal page agar tidak menambah total page
  // useEffect(() => {
  //   if (activePage === totalPage) {
  //     dispatch(setMaxPage(totalPage));
  //   }
  // }, [activePage]);

  return (
    <Container>
      {/* Title */}
      <Title
        title="Semua Loker"
        withBack
        onBack={() => dispatch(setActiveStep("page"))}
      >
        <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          {/* Pencarian */}
          <InputText
            type="text"
            value={search}
            onChange={(e) => {
              dispatch(setSearch(e.target.value));
              if (e.target.value === "") {
                dispatch(getLokerFilter());
              }
            }}
            placeholder="pencarian"
            noPadding
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                dispatch(setPagination({ ...pagination, page: 1 }));
                dispatch(getLokerFilter());
              }
            }}
            width="175px"
            borderRadius="5px"
            borderColor="#115AAA"
            iconAdornment={
              <InputAdornment
                position="start"
                className="inputAdorment"
                sx={{
                  zIndex: 200,
                  height: "40px",
                  justifyContent: "center",
                  width: "67px",
                  maxHeight: "56px",
                  borderRadius: "5px 0px 0px 5px",
                  backgroundColor: Colors.primary.hard,
                  ".MuiTypography-root": {
                    color: "white",
                    fontSize: "0.938rem",
                    fontWeight: "400",
                    lineHeight: "1.124rem",
                  },
                }}
              >
                <img
                  src={iconSearch}
                  alt="icon-search"
                  width={24}
                  height={24}
                />
              </InputAdornment>
            }
          />

          {/* Tombol Export */}
          <div style={{ display: "flex", gap: "2px" }}>
            <Button
              onClick={() => dispatch(getLokerExport())}
              padding="8px"
              width="fit-content"
              borderRadius="5px"
            >
              Export
              <img
                src={iconXls}
                style={{ marginLeft: "5px" }}
                alt="icon-slider"
                width={24}
                height={24}
              />
            </Button>
          </div>

          {/* Icon Plus */}
          <Button
            padding="12px"
            onClick={() => dispatch(setActiveStep("formulir"))}
          >
            <img alt="icon-plus" src={iconPlus} width={16} height={16} />
          </Button>

          {/* Tombol Filter */}
          <Button
            padding="8px"
            width="fit-content"
            onClick={(event) => {
              setMenuFilter(event.currentTarget);
            }}
          >
            <img src={iconSlider} alt="icon-slider" width={24} height={24} />
          </Button>
          <Menu
            id="menu-appbar"
            anchorEl={menuFilter}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              top: "40px",
              left: "10px",
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "15px",
              lineHeight: "18px",
              color: "#000000",
              "& .MuiPaper-root": {
                borderRadius: "10px",
              },
              "& .MuiList-root": {
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              },
            }}
            open={Boolean(menuFilter)}
            onClose={() => setMenuFilter(null)}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <p>Pilih Kategori Loker :</p>
              <DropDown
                dropdownValue={valueJobType}
                listDropDown={dropDownJobType}
                placeHolder="Pilih Kategori Loker"
                handleChange={(e) => {
                  dispatch(setValueJobType([e.target.value]));
                  dispatch(setPagination({ ...pagination, page: 1 }));
                  dispatch(getLokerFilter());
                }}
              />
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <p>Pilih Lokasi Loker :</p>
              <DropDown
                dropdownValue={valueCity}
                listDropDown={allCity}
                placeHolder="Pilih Lokasi Loker"
                handleChange={(e) => {
                  dispatch(setValueCity([e.target.value]));
                  dispatch(setPagination({ ...pagination, page: 1 }));
                  dispatch(getLokerFilter());
                }}
                isSearch
              />
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <p>Pilih Sektor Loker :</p>
              <DropDown
                dropdownValue={valueSector}
                listDropDown={dropDownSector}
                placeHolder="Pilih Sektor Loker"
                handleChange={(e) => {
                  dispatch(setValueSector([e.target.value]));
                  dispatch(setPagination({ ...pagination, page: 1 }));
                  dispatch(getLokerFilter());
                }}
              />
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <p>Pilih Status Loker :</p>
              <DropDown
                dropdownValue={valueStatus}
                listDropDown={[
                  {
                    label: "Semua Status",
                    value: 0,
                    status: "",
                  },
                  {
                    label: "Disetujui",
                    value: 1,
                    status: 1,
                  },
                  {
                    label: "Ditolak",
                    value: 2,
                    status: 2,
                  },
                  {
                    label: "Menunggu",
                    value: 3,
                    status: 3,
                  },
                ]}
                placeHolder="Pilih Status Loker"
                handleChange={(e) => {
                  dispatch(setValueStatus([e.target.value]));
                  dispatch(setPagination({ ...pagination, page: 1 }));
                  dispatch(getLokerFilter());
                }}
              />
            </div>
          </Menu>
        </div>
      </Title>

      {/* Table */}
      <RowWrapper>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "100%",
          }}
        >
          <Table headerContent={headerTable} dataContent={allLoker} />

          <div style={{ width: "100px", alignSelf: "flex-end" }}>
            <FormControl fullWidth>
              <InputLabel id="Select Rows Data">Rows</InputLabel>
              <Select
                labelId="Select Rows Data"
                id="rowsSelect"
                label="Rows"
                onChange={(e) => {
                  dispatch(setTableRows(e.target.value));
                  dispatch(getLokerFilter());
                }}
                value={tableRows}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          </div>

          <PageNextPrev
            totalPage={totalPage}
            activePage={activePage}
            totalData={totalData}
            onChange={(value) => {
              dispatch(
                setActivePage(
                  value === "LEFT" ? activePage - 1 : activePage + 1
                )
              );
              dispatch(getLokerFilter());
            }}
          />
        </div>
      </RowWrapper>

      <PopUp
        open={confirmDelete}
        imgSrc={iconDelete}
        type="choice"
        width="350px"
        onClose={() => {
          setConfirmDelete(false);
          dispatch(executeLoker("4", "all"));
        }}
        onClickAction={() => {
          setConfirmDelete(false);
        }}
        title="Konfirmasi"
        info="Anda yakin menghapus loker?"
      />
    </Container>
  );
};

const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

const RowWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  width: "100%",
}));

export default SemuaLoker;
